import React from 'react';
import { Container, Card } from 'react-bootstrap';
import pipeTitle from "../assets/images/pipetitle.png";
import brain from "../assets/images/brain.png";
import binacoler from "../assets/images/minacoler.png";
import award from "../assets/images/award.png";
import arrowLeft from "../assets/images/arrow-left.png";
import { Link } from 'react-router-dom';

const JoinTheFun = () => {
  return (
    <div className='app-container mobile-bottom'>
      <Container>
        <div className='breadcrum bg_light_yellow'>
          <h2 className='d-flex align-items-center mb-0 fs-20'>
          <Link to='/dashboard'> <img src={arrowLeft} width={18} className='me-2' alt="link" /></Link>
            Join The Fun</h2>
        </div>
        <div className='midtext my-4 fs-12'>
          <img src={pipeTitle} width={200} className='mb-3' alt="link" />
          <p>Enrolling your child is easy and exciting. Once you've explored the options, simply select the programs that suit your child’s interests and book it. Our flexible subscription model ensures you can customize your child's journey with us.</p>
        </div>

        <h5 className='mb-3 fs-12'>Here's what you can expect when you join:</h5>
        <Card className='mb-3 bg_dark_green border-block border-2'>
          <Card.Body className='d-flex align-items-center p-2'>
            <img src={brain} width={35} alt='dance' />
            <div className='explore_content w-100 ps-2'>
              <Card.Subtitle className='text-white fs-12'>
              A safe, inspiring space for kids to learn and grow.
              </Card.Subtitle>
            </div>
          </Card.Body>
        </Card>

        <Card className='mb-3 bg_dark_blue border-block border-2'>
          <Card.Body className='d-flex align-items-center p-2'>
            <img src={binacoler} width={35} alt='dance' />
            <div className='explore_content w-100 ps-2'>
              <Card.Subtitle className='text-white fs-12'>
              Opportunities for your child to discover, explore, and shine!
              </Card.Subtitle>
            </div>
          </Card.Body>
        </Card>

        <Card className='mb-3 bg_dark_purple border-block border-2'>
          <Card.Body className='d-flex align-items-center p-2'>
            <img src={award} width={35} alt='dance' />
            <div className='explore_content w-100 ps-2'>
              <Card.Subtitle className='text-white fs-12'>
              Expert-led programs that focus on creativity & life skills.
              </Card.Subtitle>
            </div>
          </Card.Body>
        </Card>


      </Container >
    </div >
  );
}

export default JoinTheFun;
